import { c as _c } from "react/compiler-runtime";
import { AccessibleHiddenText } from '@cc-shopping/ui/primitives/AccessibleHiddenText';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import type { StructuredContentDocumentWithRenderer, WPTableColumn, WPTableRow } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
export type WPTableProps = StructuredContentDocumentWithRenderer<{
  headers: WPTableColumn[];
  rows: WPTableRow[];
  tableBolding: '' | 'NONE' | 'FIRST_ROW' | 'FIRST_COLUMN' | 'FIRST_ROW_COLUMN';
}>;
const getTableBoldStyling = (tableBolding: string, rowIndex: number, columnIndex: number) => {
  let isBold = false;
  if (tableBolding === 'FIRST_ROW') {
    isBold = rowIndex === 0;
  } else if (tableBolding === 'FIRST_COLUMN') {
    isBold = columnIndex === 0;
  } else if (tableBolding === 'FIRST_ROW_COLUMN') {
    isBold = rowIndex === 0 || columnIndex === 0;
  }
  return {
    fontWeight: isBold ? 700 : 400
  };
};
export const WPTable = t0 => {
  const $ = _c(13);
  const {
    props
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      border: "1px solid",
      borderColor: "grey.200",
      borderTop: "2px solid",
      borderTopColor: "primary.main",
      overflowX: "auto"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== props.headers) {
    t2 = props.headers && <TableHead><TableRow>{props.headers.map(_temp)}</TableRow></TableHead>;
    $[1] = props.headers;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props.rows || $[4] !== props.tableBolding) {
    let t4;
    if ($[6] !== props.tableBolding) {
      t4 = (row, i_0) => <TableRow key={`sc-table-row-${i_0}`} sx={{
        "&:nth-of-type(odd)": {
          backgroundColor: "common.white"
        },
        "&:nth-of-type(even)": {
          backgroundColor: "grey.100"
        },
        "&:hover td": {
          backgroundColor: "secondary.light"
        }
      }}>{row.columns.map((col, j) => <TableCell colSpan={col.colspan} key={`sc-table-col-${col.id}`} sx={{
          "&:first-of-type": {
            paddingLeft: 3
          },
          "&:not(:first-of-type)": {
            borderLeft: "1px solid",
            borderLeftColor: "grey.200"
          },
          padding: 3,
          minWidth: "140px",
          ...getTableBoldStyling(props.tableBolding, i_0, j)
        }}>{col.content && renderStructuredContent(col.content)}</TableCell>)}</TableRow>;
      $[6] = props.tableBolding;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = props.rows.map(t4);
    $[3] = props.rows;
    $[4] = props.tableBolding;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <TableBody>{t3}</TableBody>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <Box sx={t1}><Table>{t2}{t4}</Table></Box>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(header, i) {
  return <TableCell key={`sc-table-header-${i}`} data-testid={`sc-table-header-${i}`} variant="head" colSpan={header.colspan} sx={{
    padding: 3,
    minWidth: "140px",
    backgroundColor: "grey.100",
    borderBottom: "1px solid",
    borderBottomColor: "grey.200",
    fontWeight: 700,
    "&:first-of-type": {
      paddingLeft: 3
    },
    "&:not(:first-of-type)": {
      borderLeft: "1px solid",
      borderLeftColor: "grey.200"
    }
  }}>{header.content ? renderStructuredContent(header.content) : <AccessibleHiddenText>Empty Table Header</AccessibleHiddenText>}</TableCell>;
}